<template>
    <div class="row">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <confirm-box ref="confirm"></confirm-box>
        <div class="d-none d-lg-block col-lg-2"></div>
        <div class="col-12 col-lg-8">
            <h1>Class Management</h1>
            <ul class="list-group">
                <li v-for="(cl, index) in classes" class="list-group-item d-flex align-items-center">
                    <template v-if="editing == cl.id">
                        <class-management-form
                            :districts="user.districts"
                            :classItem="cl"
                            :index="index"
                        ></class-management-form>
                    </template>
                    <template v-else-if="enrolling == cl.id">
                        <class-management-enrollment
                            :classItem="cl"
                        ></class-management-enrollment>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(cl.id)" title="Edit class"><i class="far fa-edit"></i></button>
                        <button type="button" class="btn btn-sm btn-primary me-2" @click="askRemove(cl.id)" title="Delete class"><i class="fas fa-trash-alt"></i></button>
                        <button type="button" class="btn btn-sm btn-primary" @click="enroll(cl.id)" title="Manage students"><i class="fas fa-users-cog"></i></button>
                        <div class="ms-3">
                            <h5 class="text-primary m-0">{{cl.name}} ({{ cl.grading_period }}) 
                            </h5>
                            <span class="text-muted">{{ cl.district_name }}</span>
                        </div>
                    </template>
                </li>
                <li class="list-group-item d-flex align-items-center">
                    <class-management-form
                        :districts="user.districts"
                    ></class-management-form>
                </li>
            </ul>
            <div class="mt-4">
                <home-button></home-button>
            </div>
        </div>
    </div>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ClassManagementForm from './ClassManagementForm.vue';
import ClassManagementEnrollment from './ClassManagementEnrollment.vue';
import HomeButton from './HomeButton.vue';
import ConfirmBox from './ConfirmBox.vue';

export default {
    components: { 
        Loading, 
        ClassManagementForm, 
        ClassManagementEnrollment, 
        HomeButton,
        ConfirmBox,
    },

    data() {
        return {
            isLoading: false,
            user: {},
            classes: [],
            editing: -1,
            enrolling: -1,
        }
    },

    mounted() {
        let dir = this.$attrs.data ?? '';
        dir = dir.match(/^(ed|en)(\d+)$/);

        if (dir) {
            if (dir[1] == 'ed') {
                this.edit(dir[2]);
            } else if (dir[1] == 'en') {
                this.enroll(dir[2]);
            }
        }

        this.isLoading = true;
        axios
            .get('/api/classes')
            .then((response) => {
                console.log(response.data.classes);
                this.user = response.data.user;
                this.classes = response.data.classes;
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        askRemove: function(id) {
            this.$refs.confirm.show({
                content: 'Are you sure you would like to delete this class?',
                title: 'Delete Class',
                callback: () => { this.remove(id) }
            });
        },
        
        remove: function(id) {
            this.isLoading = true;
            axios
                .delete(`/api/classes/${id}`)
                .then((response) => {
                    this.classes = response.data.classes;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        enroll: function(id) {
            this.editing = -1;
            this.enrolling = id;
        },

        edit: function(id) {
            this.enrolling = -1;
            this.editing = id;
        },

        home: function() {
            this.$router.push('/');
        },
    }

}
</script>